import { RouterProvider } from "react-router";
import { Notifications } from "@mantine/notifications";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";

import "./styles.scss";
import "./model";
import "../shared/configs/supertoken";

import { MantineProvider } from "@mantine/core";
import { theme } from "../shared/configs/theme";
import { SuperTokensWrapper } from "supertokens-auth-react";
import { ROUTES } from "../pages/routes";
import { router } from "../shared/libs/router";
import { useUnit } from "effector-react";
import { ModalsProvider } from "@mantine/modals";

router.initialize(ROUTES);

function App() {
  const routerInstance = useUnit(router.$instance);

  return (
    <MantineProvider theme={theme}>
      <Notifications position="bottom-right" />
      <SuperTokensWrapper>
        <ModalsProvider>
          {routerInstance && <RouterProvider router={routerInstance} />}
        </ModalsProvider>
      </SuperTokensWrapper>
    </MantineProvider>
  );
}

export default App;
